






import Vue from 'vue';

export default Vue.extend({
  props: ['buttonText'],
  methods: {
    onClickButton() {
      this.$emit('onClickButton');
    },
  },
});
